import { MiChip } from "@miplatform/components";
import { useTheme } from "@mui/material";

// TODO: Other statuses such as "Pending", "Reviewed", etc...can be added here.
const PLAN_STATUS = {
  ACTIVE: "Active",
  DRAFT: "Draft",
  INACTIVE: "Inactive",
};

export function StatusChip({ status }) {
  const theme = useTheme();

  const getChipStyle = () => {
    let color = "";
    let backgroundColor = "";

    switch (status) {
      case PLAN_STATUS.ACTIVE:
        color = theme.palette.green.main;
        backgroundColor = theme.palette.green.light;
        break;
      case PLAN_STATUS.DRAFT:
        color = theme.palette.orange.main;
        backgroundColor = theme.palette.orange.light;
        break;
      case PLAN_STATUS.INACTIVE:
        color = theme.palette.red.main;
        backgroundColor = theme.palette.red.light;
        break;
      default:
        break;
    }

    return {
      border: `1px solid ${color}`,
      color,
      backgroundColor,
      borderRadius: 1,
      height: 18,
    };
  };

  return <MiChip label={status} size="small" sx={getChipStyle()} />;
}
